export enum SampleBoardType {
  NonDestructive = 1,
  Destructive = 2
}
